export const DOCS = {
  company: {
    label: '회사소개',
    sections: [
      { title: '말투좀요란?', content: '말투좀요는 AI 기반 말투 변환 서비스로, 하고 싶은 말을 상황에 맞는 적절한 표현으로 바꿔드립니다. 직장상사, 교수님, 썸남썸녀 등 다양한 대상에 맞춘 맞춤형 변환을 제공합니다.' },
      { title: '서비스 철학', content: '키보드 워리어인 당신, 말투좀요가 현생을 살게해드립니다. 우리는 모두가 원하는 말을 올바르게 전달할 수 있도록 돕습니다.' },
      { title: '문의', content: 'rntwngus24@gmail.com' },
    ]
  },
  terms: {
    label: '이용약관',
    sections: [
      { title: '제1조 (목적)', content: '본 약관은 말투좀요(이하 "서비스")가 제공하는 말투 변환 서비스의 이용 조건 및 절차, 이용자와 서비스의 권리·의무 및 책임사항을 규정함을 목적으로 합니다.' },
      { title: '제2조 (서비스 이용)', content: '서비스는 AI 기반 말투 변환 기능을 제공합니다. 비로그인 사용자는 하루 3회 무료로 이용 가능하며, 로그인 후 말풍선을 통해 추가 이용이 가능합니다.' },
      { title: '제3조 (서비스 제공 기간)', content: '구매한 말풍선(크레딧)은 결제일로부터 1년간 사용 가능하며, 기간 만료 시 잔여 말풍선은 자동 소멸됩니다. 자동 갱신은 없습니다.' },
      { title: '제4조 (금지 행위)', content: '서비스를 통해 타인을 비방하거나 불법적인 목적으로 이용하는 행위를 금지합니다.' },
      { title: '제5조 (면책)', content: '서비스는 AI가 생성한 결과물의 정확성을 보장하지 않으며, 이를 활용한 결과에 대한 책임은 이용자에게 있습니다.' },
    ]
  },
  privacy: {
    label: '개인정보처리방침',
    sections: [
      { title: '수집하는 정보', content: '서비스는 카카오 로그인을 통해 이메일, 닉네임 등 최소한의 정보를 수집합니다. 변환 기록은 서비스 개선을 위해 저장될 수 있습니다.' },
      { title: '정보의 이용', content: '수집된 정보는 서비스 제공, 크레딧 관리, 변환 기록 저장 목적으로만 사용됩니다. 제3자에게 제공하지 않습니다.' },
      { title: '정보의 보관', content: '회원 탈퇴 시 모든 개인정보 및 변환 기록은 즉시 삭제됩니다.' },
      { title: '문의', content: '개인정보 관련 문의는 rntwngus24@gmail.com으로 연락해 주세요.' },
    ]
  }
};